import { AxiosError } from 'axios'
import { commonErrorHandle } from '@/utils/error-handle'
import { ClientJijiaInsuranceDetail } from '@/types/insurance'
import { getDeviceActiveInfo, getClientJijiaInsuranceDetail } from '@/apis/insurance'
import { clearToast, showNormalToast, showToastLoading } from '@/utils/tools'
import { isAndrod, isIos } from '@/utils/app'
import dayjs from 'dayjs'
import { isIOS } from 'vant/lib/utils'

export function useActiveHandle(
  sn: string,
  client: string,
  activeKey: string
): {
  activeHandle: (success?: boolean) => Promise<void>
} {
  let count = 1
  function loopSearch() {
    return new Promise((resolve, reject) => {
      loopSearchPinganInfo(resolve)
    })
  }
  async function loopSearchPinganInfo(resolve: (value: unknown) => void) {
    // 轮询平安信息
    try {
      const data = await getClientJijiaInsuranceDetail({ eq_sn: sn })
      if (data.status === 2 && dayjs(data.created_at).valueOf() > Date.now() - 86400000000) {
        resolve(data)
        return
      }
    } catch (error) {
      console.log('error', error)
    }
    if (count > 24) {
      resolve(null)
      return
    }
    count++
    setTimeout(() => {
      loopSearchPinganInfo(resolve)
    }, 5000)
  }
  function activeFailHandle(error: AxiosError) {
    const data = error?.response?.data || '激活失败'
    if (client === 'android' || isAndrod) {
      const android: {
        onFail?: (str: string) => void
      } = window.android
      android?.onFail(JSON.stringify(data))
    } else if (client === 'ios' || isIos) {
      window?.webkit?.messageHandlers?.addFailData?.postMessage(JSON.stringify(data))
    } else {
      commonErrorHandle(error)
    }
  }
  async function activeHandle(success = false) {
    showToastLoading()
    // 如果确定不购买会来到这里, 此时需要根据序列号查询激活信息，然后返回app查看

    try {
      const pinganInfo = success ? await loopSearch() : null
      console.log('pinganInfo', pinganInfo)
      const data = await getDeviceActiveInfo(activeKey)
      console.log('data', data)
      if (pinganInfo) {
        data.gift.unshift({
          color: null,
          event_type: 'xcare_extend_2022',
          icon: 'https://office.static.xag.cn/upload-file/umtsj468ca0008ca8/20220608/ic_jijia-d3ecf577-238f-4966-9ed7-0352593faca2.png',
          message: `意外机损保险（${
            (pinganInfo as ClientJijiaInsuranceDetail).product_info.pro_type_text
          }）`,
          numerical_value: '1年',
          success: true,
          type: null,
        })
      }
      if (client === 'android' || isAndrod) {
        const android: {
          onSuccess?: (str: string) => void
        } = window.android
        android?.onSuccess(JSON.stringify(data))
      } else if (client === 'ios' || isIos) {
        window?.webkit?.messageHandlers?.addSuccessData?.postMessage(JSON.stringify(data))
      } else {
        showNormalToast('激活成功, 请在极飞农服app查看结果')
      }
      clearToast()
    } catch (error) {
      activeFailHandle(error as AxiosError)
    }
  }
  return {
    activeHandle,
  }
}
